<template>
  <div>
    <router-view></router-view>
    <ThePWAPrompt/>
    <TheCookieBanner/>
  </div>
</template>

<script>
import TheCookieBanner from "@/components/TheCookieBanner.vue"
import ThePWAPrompt from "@/components/ThePWAPrompt.vue";

export default {
  components: {
    TheCookieBanner,
    ThePWAPrompt
  }
}
</script>

<style lang="scss">
</style>
